export const load = () => ({
	h1: 'Modern Energy and Acoustic Performance for Legacy Windows',
	title: 'IndowPRO for Architects | High-Performance Window Retrofit Solutions',
	description:
		'IndowPRO is the high-performance secondary glazing system that meets demanding energy and acoustic standards without replacing original windows. Access your complete technical resource library for architects.',
	showTitle: true,

	headerPosition: 'relative',
});
